export default __webpack_public_path__ + "static/media/arrow-left.1272f206.svg";